export const API_PATH = {
  baseURL: process.env.VUE_APP_API_URL,//VUE_APP_API_URL=https://api-fact-checker.line-local.com:8091
  api: process.env.VUE_APP_API_VERSION,//VUE_APP_API_VERSION=/pub/v1
  apiPartner: process.env.VUE_APP_PARTNER_API_VERSION,//VUE_APP_API_VERSION=/pub/v1,
  temporaryArticles: '/temporaryArticles',
  temporaryArticleToArticle: '/temporaryArticles/toArticle',
  articles: '/articles',
  articleRelatToOtherArticle: '/articles/:articleId/relateTo/:parentArticleId'
};
